__webpack_require__.p = "https://releases.rancher.com/dashboard/release-2.14/";